import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Comments|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

export type SPCandidateSystemActivityCommentsModalLocNames =
	| 'SPCandidateSystemActivityCommentsModalTitle'
	| 'SPCandidateSystemActivityCommentsModalFieldLabelCandidate'
	| 'SPCandidateSystemActivityCommentsModalFieldLabelCandidateId'
	| 'SPCandidateSystemActivityCommentsModalButtonCancel'
	| 'SPCandidateSystemActivityCommentsModalButtonAddCommentSubmit';

export const spCandidateSystemActivityCommentsModalLocs: LocDefs<SPCandidateSystemActivityCommentsModalLocNames> =
	{
		SPCandidateSystemActivityCommentsModalTitle: {
			defaultValue: 'Add Candidate Comment',
			description: 'Dialog title',
			displayPath: `${pathStart}Dialog title`,
			displayType: 'Title',
			legacyName: 'Core/Candidates.Comments.Title.ModalTitle',
			...sharedProperties,
		},
		SPCandidateSystemActivityCommentsModalFieldLabelCandidate: {
			defaultValue: 'Candidate',
			description: 'Field label for: Candidate.',
			displayPath: `${pathStart}Candidate`,
			displayType: 'Label',
			legacyName: 'Core/Candidates.Comments.FieldLabel.Candidate',
			...sharedProperties,
		},
		SPCandidateSystemActivityCommentsModalFieldLabelCandidateId: {
			defaultValue: 'Candidate ID',
			description: 'Field label for: Candidate ID.',
			displayPath: `${pathStart}Candidate ID`,
			displayType: 'Label',
			legacyName: 'Core/Candidates.Comments.FieldLabel.CandidateId',
			...sharedProperties,
		},
		SPCandidateSystemActivityCommentsModalButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Button to cancel the comment',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Core/Candidates.Comments.Button.Cancel',
			...sharedProperties,
		},
		SPCandidateSystemActivityCommentsModalButtonAddCommentSubmit: {
			defaultValue: 'Add Comment',
			description: 'Button to add the comment',
			displayPath: `${pathStart}Add Comment`,
			displayType: 'Button',
			legacyName: 'Core/Candidates.Comments.Button.AddCommentSubmit',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityCommentsModalLocType =
	LocMap<SPCandidateSystemActivityCommentsModalLocNames>;
